<template>
  <ion-page>
    <ion-content class="welcome-content">
      <div class="background-scene">
        <div class="stars"></div>
        <div class="mountains"></div>
      </div>

      <div class="delete-scenario-page-container">
        <div class="glass-card delete-scenario-card">
          <div class="delete-scenario-page-header">
            <h1 class="delete-scenario-page-title">Delete Scenario</h1>
          </div>

          <div class="delete-scenario-info">
            <div class="scenario-details">
              <div class="delete-scenario-name">{{ scenarioToDelete?.name }}</div>
              <div v-if="scenarioToDelete?.description" class="delete-scenario-description">
                {{ scenarioToDelete.description }}
              </div>
            </div>
          </div>

          <div class="delete-scenario-warning-section">
            <ion-icon :icon="warningOutline" class="delete-scenario-warning-icon"></ion-icon>
            <h3 class="delete-scenario-warning-title">Warning</h3>
            <p class="delete-scenario-warning-message">
              You are about to delete the scenario "{{ scenarioToDelete?.name }}". This action will permanently remove all associated data with this scenario and it will no longer be accessible.
            </p>
            <p class="delete-scenario-warning-question">Are you sure you want to continue?</p>
          </div>

          <div class="delete-scenario-form-actions">
            <ion-button fill="outline" class="delete-scenario-cancel-button" @click="goBack">
              Cancel
            </ion-button>
            <ion-button expand="block" class="delete-scenario-delete-button" @click="confirmDelete">
              Delete Scenario
            </ion-button>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonButton, IonLabel, IonIcon } from '@ionic/vue';
import { warningOutline } from 'ionicons/icons';
import { useScenariosStore } from '@/store/scenarios';

export default {
  name: 'DeleteScenarioPage',
  components: {
    IonPage, IonContent, IonButton, IonLabel, IonIcon
  },

  setup() {
    const scenariosStore = useScenariosStore();
    return { scenariosStore };
  },

  data() {
    return {
      warningOutline,
      scenarioToDelete: null
    }
  },

  computed: {
    profileID() {
      return this.$route.query.profileID || localStorage.getItem('userID');
    }
  },

  mounted() {
    // Set the profile in the scenarios store
    if (this.profileID) {
      this.scenariosStore.setProfile({ id: this.profileID });
    }
    
    // Get scenario data from route query
    const scenarioId = this.$route.query.scenarioId;
    const scenarioName = this.$route.query.scenarioName;
    const scenarioDescription = this.$route.query.scenarioDescription;
    
    if (scenarioId && scenarioName) {
      this.scenarioToDelete = {
        id: scenarioId,
        name: scenarioName,
        description: scenarioDescription
      };
    } else {
      // If no scenario data provided, redirect back
      this.goBack();
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async confirmDelete() {
      try {
        if (!this.scenarioToDelete) {
          console.error('=== SCENARIO DELETION FAILURE ===');
          console.error('No scenario to delete - scenario data is missing');
          return;
        }
        
        console.log('=== SCENARIO DELETION ATTEMPT ===');
        console.log('Attempting to delete scenario:', {
          scenarioID: this.scenarioToDelete.id,
          scenarioName: this.scenarioToDelete.name,
          scenarioDescription: this.scenarioToDelete.description || 'No description available',
          profileID: this.profileID,
          timestamp: new Date().toISOString()
        });
        
        await this.scenariosStore.deleteScenario(this.scenarioToDelete.id);
        
        console.log('=== SCENARIO DELETION SUCCESS ===');
        console.log('Successfully deleted scenario:', {
          scenarioID: this.scenarioToDelete.id,
          scenarioName: this.scenarioToDelete.name,
          scenarioDescription: this.scenarioToDelete.description || 'No description available',
          profileID: this.profileID,
          timestamp: new Date().toISOString()
        });
        
        // Navigate back to the previous page
        this.$router.go(-1);
      } catch (error) {
        console.error('=== SCENARIO DELETION FAILURE ===');
        console.error('Failed to delete scenario:', {
          scenarioID: this.scenarioToDelete?.id || 'Unknown',
          scenarioName: this.scenarioToDelete?.name || 'Unknown',
          scenarioDescription: this.scenarioToDelete?.description || 'No description available',
          profileID: this.profileID,
          error: error.message,
          timestamp: new Date().toISOString()
        });
        console.error('Full error details:', error);
      }
    }
  }
}
</script>
